// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateSearchDropDown = key => ({
    key,
    type: actions.UPDATE_PIP_SEARCH_BY
});



// WEBPACK FOOTER //
// ./src/pip/shared/action-creators/search-dropdown.js